import { useNavigate } from "react-router-dom"
import toast, { Toaster } from "react-hot-toast";
import { numberWithThousandSeparator } from "../../../helpers/utils";
import React from "react";

import { Card, Table } from "reactstrap";
import { Form, Col, Row } from "react-bootstrap";

import { Edit2, Watch, Filter, Eye } from "react-feather";

import { InventoryProduct } from "../../../types/inventory";
import { useQueryRetrieveCategories, useQueryRetrieveInventory } from "../../../services/stores/queries";
import { useSessionStore } from "../../../services/stores";
import { blankSplitFertigation, Category, Inventory, productCategory, ProductCategory } from "../../../types";
import LoadingInPogress from "../../../components/LoadingInProgress";
import { InventoryPesticideFilter } from "./InventoryPesticideFilter";
import { useEffect, useState } from "react";
import { ProgressBar } from 'react-bootstrap';
import styled from 'styled-components';

const StyledProgressBar = styled(ProgressBar)`
    margin-bottom: 0;  // Remove default margin
    height: 20px;     // Adjust height as needed
    background-color: transparent;  // Make background transparent
    
    .progress-bar {
        font-size: 0.8rem;
        font-weight: bold;
    }
`;

const ProductCard = styled(Card)`
  margin-bottom: 1rem;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  background-color: white;
  
  .card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: ${props => props.index % 2 === 0 ? '#cfe2ff' : '#f8f9fa'};
    border-bottom: 1px solid #dee2e6;
  }
  
  .product-image {
    width: 40%;
    padding: 1rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  .product-details {
    width: 60%;
    padding: 1rem;
  }
  
  .detail-row {
    display: flex;
    justify-content: space-between;
    margin-bottom: 0.5rem;
  }
  
  .progress-row {
    padding: 0.5rem 1rem;
    border-top: 1px solid #dee2e6;
    display: flex;
    align-items: center;
    background-color: ${props => props.index % 2 === 0 ? '#f8f9fa' : 'white'};
  }

  .bottom-row {
    margin: 0;  // Remove default Row margin
    border-top: 1px solid #dee2e6;
    background-color: ${props => props.index % 2 === 0 ? '#f8f9fa' : 'white'};
    
    > div {  // Target Col elements
      padding: 0.5rem;  // Consistent padding
    }
  }

  .actions {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
  }
`;

interface InventoryProductCardProps extends InventoryProduct {
  index: number,
  filter: productCategory
}

const InventoryProductCard = (product: InventoryProductCardProps) => {
  const navigate = useNavigate();
  const currentFarm = useSessionStore(state => state.currentFarm);

  const onEditProduct = () => {
    console.log(product);
    navigate("/products/inventory/product-transactions", {state: product}) 
  }

  const getProgressBarVariant = (ratio: number): string => {
    if (ratio >= 0.9) return 'danger';     // Red
    if (ratio >= 0.7) return 'warning';    // Yellow
    if (ratio >= 0.5) return 'info';       // Blue
    return 'success';                       // Green
};

  const consumptionRatio = product.quantityConsumed / product.quantityTotal;
  const consumptionPercentage = Math.round(consumptionRatio * 100);

  const className1 =  (product.index % 2 === 0)? 'table-primary hoverable' : 'hoverable';
  const className2 =  (product.quantity + product.quantityPlanned < 0.001)? 'not-in-stock' : 'hoverable';
  const className3 =  ((product.quantity < 0.001) && (product.quantityPlanned > 0.001))? 'all-planned' : '';

  return (
    <ProductCard index={product.index}>
      <div className="card-header">
        <h5 className="mb-0">{product.productName}</h5>
        <span>{product.quantity.toFixed(2)} {product.uom}</span>
      </div>
      <div style={{ display: 'flex' }}>
        <div className="product-image">
          <img 
            src={product.imageURL || 'placeholder-image-url'} 
            alt={product.productName}
            style={{ maxWidth: '100%', height: 'auto' }}
          />
        </div>
        <div className="product-details">
          {product.quantityConsumed > 0 && (
            <div className="detail-row">
              <span>Consommé:</span>
              <strong>{numberWithThousandSeparator(Number(product.quantityConsumed.toFixed(3)))}</strong>
            </div>
          )}
          {product.quantityPlanned > 0 && (
            <div className="detail-row">
              <span>Programmé:</span>
              <strong>{numberWithThousandSeparator(Number(product.quantityPlanned.toFixed(3)))} {product.uom}</strong>
            </div>
          )}
        </div>
      </div>
      <Row className="bottom-row">
        <Col xs={10} style={{ paddingRight: 0 }}>
          {consumptionRatio > 0 && (
            <StyledProgressBar style={{ width: '100%' }}>
              <ProgressBar 
                variant={getProgressBarVariant(consumptionRatio)}
                now={consumptionPercentage} 
                label={`${consumptionPercentage}%`}
                striped={consumptionRatio > 0.9}
              />
            </StyledProgressBar>
          )}
        </Col>
        <Col xs={2} style={{ paddingLeft: 0 }}>
          <div className="actions">
            <Eye className="align-middle" size={18} onClick={onEditProduct} />
          </div>
        </Col>
      </Row>
    </ProductCard>
  );
}

export const InventoryComponent = () => {

  const [pesticideFilter, setPesticideFilter] = useState<"ALL" | "FONGICIDE" | "INSECTICIDE" | "NUTRITION FOLIAIRE" | "NUTRITION RACINAIRE">("ALL");
  const [showZeroAmount, setShowZeroAmount] = useState(false);
  const [showFilters, setShowFilters] = useState(false);

  const { data: inventory, 
          error: errorInventory, 
          isLoading: isLoadingInventory  
    } = useQueryRetrieveInventory();

    const [filteredProducts, setFilteredProducts] = useState<InventoryProduct[]>([]);

    const { data: allCategories, 
          error: errorAllCategories, 
          isLoading: isLoadingAllCategories
    } = useQueryRetrieveCategories();


  const errorMessage = errorInventory?.message;

  useEffect(() => {

    const filterCategory = allCategories?.find((category: Category) => category.name.toUpperCase() === pesticideFilter);  

    const filteredProducts = inventory?.products.filter((product: InventoryProduct) => {
      if (!showZeroAmount && product.quantityTotal <=  (product.quantityConsumed +0.09)) {
        return false;
      }

      if (pesticideFilter === "ALL") {
        return true;
      } else {
        return product.categories?.find((category: ProductCategory) => category.categoryID === filterCategory?.id) != undefined; 
      }
    })

    setFilteredProducts(filteredProducts || []);

  }, [inventory, pesticideFilter, showZeroAmount]);


  if (isLoadingInventory && !errorInventory) {
    return (
        <LoadingInPogress message="Chargement de l'inventaire en cours"/>
    )
  }

  return (
    <React.Fragment>
      <div><Toaster/></div>
      {errorMessage && <h6 style={{color: 'red'}}>{errorMessage}</h6>}
      <Row style={{ 
        padding: '0.5rem',
        margin: '0 0 10px 0',
        backgroundColor: '#f8f9fa',
        alignItems: 'center',
        justifyContent: 'flex-end'
      }}>
        <Col xs="auto">
          <Filter 
            size={20} 
            className="cursor-pointer" 
            onClick={() => setShowFilters(!showFilters)}
            style={{ cursor: 'pointer' }}
          />
        </Col>
        {showFilters && (
          <Col xs={12} style={{
            marginTop: '0.5rem',
            padding: '1rem',
            border: '1px solid #dee2e6',
            borderRadius: '4px',
            backgroundColor: 'white'
          }}>
            <Row>
              <Col xs={12} md={8}>
                <InventoryPesticideFilter filter={pesticideFilter} setFilter={setPesticideFilter}/>
              </Col>
              <Col xs={12} md={3}>
                <Form.Check
                  type="checkbox"
                  id="show-zero-amount"
                  label="Inclure quantité = 0"
                  checked={showZeroAmount}
                  onChange={(e) => setShowZeroAmount(e.target.checked)}
                />
              </Col>
            </Row>
          </Col>
        )}
      </Row>
      <Row style={{ 
        padding: '0.5rem',
        margin: 0,
        backgroundColor: '#edf2f7'
      }}>
        {filteredProducts?.map((product: InventoryProduct, index: number) => (
          <Col xs={12} key={product.productID} style={{ padding: '0.25rem' }}>
            <InventoryProductCard {...product} index={index} filter={pesticideFilter} />
          </Col>
        ))}
      </Row>
    </React.Fragment>
  );
};
